(function () {

  const grid = document.getElementById('gcGrid');
  if (!grid) return;
  
  const previewImg = document.getElementById('gcPreviewImage');
  const previewPlaceholder = document.getElementById('gcPreviewPlaceholder');
  const message = document.getElementById('gcMessage');
  const chars = document.getElementById('gcChars');
  const actionBtns = document.querySelectorAll('.gc-action-btn'); // Теперь массив кнопок
  const topBlock = document.getElementById('gcTop');
  const errorEl = document.getElementById('gcError');

  let selectedCard = null;
  let selectedVariantId = null;
  let busy = false;
  let interactionSeq = 0;

  const cards = [...grid.querySelectorAll('.gc-card')];
  const CARD_VARIANT_IDS = new Set(cards.map(c => c.getAttribute('data-variant-id')).filter(Boolean));
  const CARD_PRODUCT_IDS = new Set(cards.map(c => c.getAttribute('data-product-id')).filter(Boolean));
  const isCardLine = item => CARD_VARIANT_IDS.has(String(item.variant_id)) || CARD_PRODUCT_IDS.has(String(item.product_id));

  // MFS-5764 single-card mode (club card step): one preselected card, the main
  // button reads Skip / "Add card £2.99" by the text, the header Skip always
  // skips. See sections/page-gifts.liquid.
  const section = document.getElementById('greeting-card-section');
  const isSingle = Boolean(section && section.dataset.gcMode === 'single');
  const addLabel = isSingle ? section.dataset.gcAddLabel : '';
  const headerSkip = document.getElementById('gcActionBtn2');
  const maxChars = Number(message.getAttribute('maxlength')) || 0;

  function resetButtons() {
    if (busy) return;
    if (isSingle) {
      const hasText = message.value.trim().length > 0;
      actionBtns.forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        if (btn === headerSkip) return; // the header link always says Skip
        btn.textContent = hasText ? addLabel : 'Skip';
        btn.classList.toggle('skip', !hasText);
      });
      return;
    }
    actionBtns.forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      if (selectedVariantId) {
        btn.textContent = 'Continue';
        btn.classList.remove('skip');
      } else {
        btn.textContent = 'Skip';
        btn.classList.add('skip');
      }
    });
  }

  function setBusy(on, label) {
    busy = on;
    if (!on) {
      resetButtons();
      return;
    }
    actionBtns.forEach(btn => {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      if (label) btn.textContent = label;
    });
  }


  function autoResizeMessage() {
    message.style.height = 'auto';
    message.style.height = message.scrollHeight + 'px';
  }

  message.addEventListener('input', () => {
    interactionSeq++;
    // Text set from code (the AI generator) skips maxlength — keep the limit anyway
    if (maxChars && message.value.length > maxChars) message.value = message.value.slice(0, maxChars);
    chars.textContent = message.value.length;
    autoResizeMessage();
    if (isSingle) {
      resetButtons();
      return;
    }

    if (message.value.trim().length > 0 && !selectedVariantId) {
      const firstCard = grid.querySelector('.gc-card');
      if (firstCard) {
        selectCard(firstCard);
      }
    }
  });

  function clearSelection() {
    const prev = grid.querySelector('.gc-card.selected');
    if (prev) prev.classList.remove('selected');
    selectedCard = null;
    selectedVariantId = null;
    previewImg.style.display = 'none';
    previewImg.src = '';
    previewPlaceholder.style.display = 'block';
    resetButtons();
  }

  function selectCard(cardEl, skipScroll = false) {
    clearSelection();
    cardEl.classList.add('selected');
    selectedCard = cardEl;
    selectedVariantId = cardEl.getAttribute('data-variant-id');

    const img = cardEl.querySelector('.thumb img');
    if (img && img.src) {
      previewImg.src = img.src;
      previewPlaceholder.style.display = 'none';
      previewImg.style.display = 'block';
    }

    resetButtons();
    if (!skipScroll) {
      topBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  grid.addEventListener('click', (e) => {
    const card = e.target.closest('.gc-card');
    if (!card) return;
    interactionSeq++;
    if (card.classList.contains('selected')) {
      clearSelection();
    } else {
      selectCard(card);
    }
  });

  // MFS-5764 mixed cart: at most one card of each kind in the cart — one club
  // card (£2.99) and one ordinary card. The kind is what this page's grid holds
  // (isCardLine; the club card step has only the club card), so a card added
  // here replaces every card of the same kind, whichever bouquet it was linked
  // to. The new card is linked to the bouquet being ordered (_bundle_of,
  // assets/club-cart.js).
  function bundleChildProps(cart) {
    return window.MFClub && window.MFClub.bundleChildProps ? window.MFClub.bundleChildProps(cart) : {};
  }

  // The card to show when the page opens: the one linked to this bouquet first
  function ownCard(cart) {
    const bundle = bundleChildProps(cart)._bundle_of;
    const sameKind = cart.items.filter(isCardLine);
    return (bundle && sameKind.find(i => i.properties && i.properties._bundle_of === bundle)) || sameKind[0];
  }

  function reportError(err) {
    console.error('[gifts] cart update failed', err);
    if (window.Sentry && typeof window.Sentry.captureException === 'function') window.Sentry.captureException(err);
  }

  function setError(visible) {
    if (errorEl) errorEl.hidden = !visible;
  }

  async function handleActionBtnClick(event) {
    if (busy) return;
    setError(false);
    if (!window.CartService || typeof window.CartService.replaceLines !== 'function') {
      reportError(new Error('CartService missing'));
      setError(true);
      return;
    }

    const text = message.value.trim();
    // Single-card mode: no text, or the header Skip → no card (and drop one
    // added on an earlier visit), straight on to checkout
    const skip = isSingle && (!text || event.currentTarget === headerSkip);
    const variantId = skip ? null : selectedVariantId;
    const properties = { "Note": text };
    if (message.dataset.aiUsed === 'true') properties['_ai_card_used'] = 'true';

    setBusy(true, variantId ? 'Adding...' : null);

    try {
      if (variantId) Object.assign(properties, bundleChildProps(await window.CartService.getCart(true)));
      await window.CartService.replaceLines({
        match: isCardLine,
        add: variantId ? { variantId: Number(variantId), quantity: 1, properties } : null
      });
      window.location.href = '/checkout';
    } catch (err) {
      reportError(err);
      setBusy(false);
      setError(true);
    }
  }

  actionBtns.forEach(btn => {
    btn.addEventListener('click', handleActionBtnClick);
  });

  function restoreStateFromCart(force) {
    if (!window.CartService || typeof window.CartService.getCart !== 'function') {
      console.error('[gifts] CartService missing');
      resetButtons();
      return Promise.resolve();
    }

    const seq = interactionSeq;
    return window.CartService.getCart(!!force)
      .then(cart => {
        if (seq !== interactionSeq) return resetButtons();

        const item = ownCard(cart);
        const cardEl = item && (grid.querySelector(`.gc-card[data-variant-id="${item.variant_id}"]`)
          || grid.querySelector(`.gc-card[data-product-id="${item.product_id}"]`));

        if (cardEl) {
          selectCard(cardEl, true);
          if (item.properties && typeof item.properties.Note === 'string') message.value = item.properties.Note;
          if (item.properties && item.properties._ai_card_used === 'true') message.dataset.aiUsed = 'true';
          else delete message.dataset.aiUsed;
        } else if (!isSingle) {
          clearSelection();
        }

        chars.textContent = message.value.length;
        autoResizeMessage();
        resetButtons();
      })
      .catch(err => {
        console.error('[gifts] cart restore failed', err);
        resetButtons();
      });
  }

  if (isSingle) {
    const onlyCard = grid.querySelector('.gc-card');
    if (onlyCard) selectCard(onlyCard, true);
  }
  chars.textContent = message.value.length;
  restoreStateFromCart(false);
  autoResizeMessage();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      busy = false;
      setError(false);
      resetButtons();
      restoreStateFromCart(true);
    }
  });

})();